export const CloverGatewayEnvironment = {
    PRODUCTION: 'PRODUCTION',
    SANDBOX: 'SANDBOX',
} as const;

export type CloverGatewayEnvironment =
    (typeof CloverGatewayEnvironment)[keyof typeof CloverGatewayEnvironment];
